// extracted by mini-css-extract-plugin
export var cardIcon = "_s-5";
export var cardIconUnframed = "_s-9";
export var checkboxCard = "_s-0";
export var checkboxCardSelected = "_s-4";
export var disabled = "_s-2";
export var interactive = "_s-1";
export var outerBorder = "_s-3";
export var spacerMedium = "_s-8";
export var spacerSmall = "_s-7";
export var spacerXsmall = "_s-6";